var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"ml-1",class:{
    'text-gray-400': _vm.value !== _vm.field,
  },attrs:{"icon":['fas', 'sort-alpha-down' + _vm.directionIcon]}})}
var staticRenderFns = []

export { render, staticRenderFns }